import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";

export default function PrivacyPage() {
  return (
    <>
      <Navbar />
      <div style={{ padding: "40px", maxWidth: "800px", margin: "0 auto" }}>
        <h1>Privacy Policy</h1>
        <p><strong>Last Updated:</strong> 15 June 2025</p>

        <p>
          At Quizzards, we are committed to protecting your personal data and respecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information in accordance with the UK General Data Protection Regulation (UK GDPR).
        </p>

        <h2>1. Who We Are</h2>
        <p>
          Quizzards is an educational technology platform offering learning, testing, and performance-tracking tools. If you have any questions about this policy or how your data is handled, please contact us.
         
        </p>

        <h2>2. What Data Might We Collect</h2>
        <ul>
          <li><strong>Account Data:</strong>Name email address, password, age</li>
          <li><strong>Usage Data:</strong> Login times, activity logs, test results</li>
          <li><strong>Technical Data:</strong> IP address, browser type, operating system</li>
          <li><strong>Communications:</strong> Support queries and feedback</li>
        </ul>

        <h2>3. How We Use Your Data</h2>
        <p>We use your personal data to:</p>
        <ul>
          <li>Provide and personalise your experience on our platform</li>
          <li>Process test results and show progress tracking</li>
          <li>Communicate with you about your account or updates</li>
          <li>Ensure platform security and prevent fraud</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2>4. Legal Basis for Processing</h2>
        <p>We process your data under one or more of the following legal bases:</p>
        <ul>
          <li>Your consent (e.g. when signing up)</li>
          <li>Contractual necessity (e.g. to deliver our services)</li>
          <li>Legal compliance (e.g. safeguarding, fraud detection)</li>
          <li>Legitimate interests (e.g. platform analytics, improvements)</li>
        </ul>

        <h2>5. Data Retention</h2>
        <p>
          We retain your data for as long as you have an active account, and for a reasonable period thereafter for legal or operational purposes. You may request deletion at any time.
        </p>

        <h2>6. Sharing of Data</h2>
        <p>
          We do not sell your data. We may share it with trusted third-party processors (e.g. cloud hosting or analytics providers) under strict confidentiality agreements. We ensure all partners are GDPR-compliant.
        </p>

        <h2>7. International Transfers</h2>
        <p>
          If we transfer your data outside the UK, we ensure appropriate safeguards (e.g. UK GDPR adequacy decisions or standard contractual clauses).
        </p>

        <h2>8. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your data</li>
          <li>Request correction or deletion</li>
          <li>Object to or restrict processing</li>
          <li>Withdraw consent</li>
          <li>Lodge a complaint with the UK Information Commissioner’s Office (ICO)</li>
        </ul>

        <h2>9. Cookies and Tracking</h2>
        <p>
          We use cookies to improve functionality and understand user behavior. You can control cookies through your browser settings.
        </p>

        <h2>10. Changes to This Policy</h2>
        <p>
          We may update this policy from time to time. We will notify you of significant changes via email or through the platform.
        </p>

        <p>By using Quizzards, you agree to the terms of this Privacy Policy.</p>
      </div>
      <Footer />
    </>
  );
}
